import { render, staticRenderFns } from "./BtnExcluirAditivo.vue?vue&type=template&id=edf8554a"
import script from "./BtnExcluirAditivo.vue?vue&type=script&lang=js"
export * from "./BtnExcluirAditivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports